export default __webpack_public_path__ + "fb6e72935a7fd345616d0e135bf897e8.png";